// extracted by mini-css-extract-plugin
module.exports = {"ttsBtn":"_2p8ac0wGmQwvO7JvBsm6Pn","ttsIcon":"_3OdBW4WGFU1qSM-2IxXvzA","active":"_1FeB9fTkL0Qz9fxxZJQw7Z"};